import { Injectable } from '@angular/core';
import { createAuth0Client, Auth0Client } from '@auth0/auth0-spa-js';
import { AppStateService } from './app-state.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class MultiAuthService {
  private essayClient: Auth0Client | null = null;
  private competitionId!:string 
  public auth0Id: any;
  constructor(private appState: AppStateService, 
              private router: Router,
              private route: ActivatedRoute) {}

  async getEssayClient() {
    const competitionId = localStorage.getItem('competitionId');
    this.essayClient = await createAuth0Client({
      domain: 'ekitabu.eu.auth0.com',
      clientId: '5ct2aWBjF4bK5UM2YVkPseL9BaSCCkcz',
      cacheLocation: 'memory', // Use memory to avoid persisting tokens in local storage
      authorizationParams: {
        prompt: 'login',
        redirect_uri: `${window.location.origin}/online-essay/`,
      },
    });
    return this.essayClient;
  }

  async loginOnlineEssay(competitionId: string) {
    this.competitionId = localStorage.getItem('competitionId');;
    console.log("compId =>> ", this.competitionId);
    const essayClient = await this.getEssayClient();

    await essayClient.loginWithRedirect({
      appState: { target: `online-essay/`, sourceApp: `${this.competitionId}` },
    });

  }

  async handleLoginCallback() {
    try{
      const essayClient = await this.getEssayClient();
      console.log(essayClient);
      await essayClient.handleRedirectCallback();
      const user = await essayClient.getUser();
      console.log("user ", user);
      const valid = await essayClient.isAuthenticated();
      console.log(valid);
      this.auth0Id = user.sub;
      const token = await essayClient.getTokenSilently({ cacheMode: 'off' });
      this.router.navigate([`/online-essay/${this.appState.sourceApp}/submission-type`]);
    }catch{
      this.router.navigate([`/online-essay/${this.appState.sourceApp}/welcome`]);
    }

  }

  async logout() {
    const essayClient = await this.getEssayClient();
    // Clear local authentication state
    this.auth0Id = null;
    // Perform Auth0 logout
    await essayClient.logout({
      logoutParams: {
        client_id: '5ct2aWBjF4bK5UM2YVkPseL9BaSCCkcz',
        returnTo: window.location.origin
      }
    });

    // Reset the client instance to ensure clean state for next login
    this.essayClient = null;
  }

  async isAuthenticated(): Promise<boolean> {
    const essayClient = await this.getEssayClient();
    return essayClient.isAuthenticated();
  }

  
}
